export default __webpack_public_path__ + "images/labeling_step_guide_2-peBtV.gif";